import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Group } from '@rillion/components/sidebar/sidebar.component';
import { AuthSelectors } from '@rillion/store/auth';
import { Store } from '@ngrx/store';
import { LicenceModel } from '../../../../libs/system';
import { OperationPermissions } from '@rillion/shared/enums/operation-permission';
import { TranslateService } from '@ngx-translate/core';

export interface NavigatorState {
  groups: Group[];
}

const getInitialState = (): NavigatorState => ({
  groups: [],
});

@Injectable()
export class NavigatorStore extends ComponentStore<NavigatorState> {
  // Global store
  private readonly operationPermissions$ = this.store.select(AuthSelectors.selectOperationPermissions);
  private readonly licences$ = this.store.select(AuthSelectors.selectLicences);

  // Local store
  readonly groups$ = this.select(this.operationPermissions$, this.licences$, (operatingPermissions, licences) => this.createGroups(operatingPermissions, licences));

  constructor(
    private readonly store: Store,
    private readonly translateService: TranslateService,
  ) {
    super(getInitialState());
  }

  private createGroups(operatingPermissions: Record<string, number>, licence: LicenceModel[]) {
    const routes: Group[] = [
      {
        items: [
          {
            icon: 'dashboard',
            link: '/dashboard',
            text: this.translateService.instant('Dashboard'),
            // children: [
            //   {
            //     text: 'BACK TO OLD VERSION',
            //     link: this.appSettingsService.appSettings.loginRedirectUrl,
            //     external: true,
            //   },
            // ],
          },
          // {
          //   icon: 'person',
          //   link: '/profile',
          //   text: 'MY PROFILE',
          // },
        ],
      },
      {
        items: [],
      },
      {
        items: [],
      },
    ];

    if (!licence) {
      return routes;
    }
    //needed permissions for each meny item to be added later
    // const expenditure = operatingPermissions[OperationPermissions.Expenditure] >= 1;
    // const buyer = operatingPermissions[OperationPermissions.Buyer] >= 1;
    const invoice = operatingPermissions[OperationPermissions.Invoice] >= 1;
    // const contracts = operatingPermissions[OperationPermissions.Contract] >= 1;
    // const document = operatingPermissions[OperationPermissions.Document] >= 1;
    // const report = operatingPermissions[OperationPermissions.Report] >= 1;
    // const administration = operatingPermissions[OperationPermissions.Administration] >= 1;
    // const system = operatingPermissions[OperationPermissions.System] >= 1;

    // if (report) {
    //   routes[2].items.push({
    //     text: 'REPORTS',
    //     link: '/reports',
    //     icon: 'pie_chart',
    //   });
    // }
    // if (administration) {
    //   routes[2].items.push({
    //     text: 'ADMINISTRATION',
    //     link: '/administration',
    //     icon: 'admin_panel_settings',
    //   });
    // }
    // if (system) {
    //   routes[2].items.push({
    //     text: 'SYSTEM',
    //     link: '/settings',
    //     icon: 'settings',
    //   });
    // }

    // if (buyer && licence[0]['haveBuyer']) {
    //   routes[1].items.push({
    //     text: 'REQUISITIONS',
    //     link: '/requisitions',
    //     icon: 'list_alt',
    //   });
    // }
    // if (expenditure && licence[0]['haveExpenditure']) {
    //   routes[1].items.push({
    //     text: 'BUDGET REQUESTS',
    //     link: '/budget',
    //     icon: 'request_quote',
    //   });
    // }

    if (invoice && licence[0]['haveInvoice']) {
      routes[1].items.push({
        icon: 'receipt_long',
        link: '/invoices',
        text: this.translateService.instant('Invoices'),

        // TODO: Replace with below when invoice log should be released
        // icon: 'receipt_long',
        // link: '/invoice-log',
        // text: 'INVOICES',
        // children: [
        //   {
        //     text: 'INVOICE LOG',
        //     link: '/invoice-log',
        //   },
        //   {
        //     text: 'INVOICE INBOX',
        //     link: '/invoices',
        //   },
        // ],
      });
    }
    //commented out until we add the menus functionalities
    // if (contracts && licence[0]['haveContract']) {
    //   routes[1].items.push({
    //     text: 'CONTRACTS',
    //     link: '/contracts',
    //     icon: 'handshake',
    //   });
    // }

    // if (document && licence[0]['haveDocument']) {
    //   routes[1].items.push({
    //     text: 'DOCUMENTS',
    //     link: '/documents',
    //     icon: 'topic',
    //   });
    // }

    return routes;
  }
}
